import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonUI from '../../../components/ui/button/button';
import { useTranslation } from 'react-i18next';
import PreviewImageUI from '../../../components/ui/preview-image/preview-image';
import FieldsetUI from '../../../components/ui/fieldset/fieldset';
import SwalUI from '../../../components/ui/swal-ui/swal-ui';
import { svUpdateCategory } from '../../../services/category.service';
import RadioBoxUI from '../../../components/ui/radio-box/radio-box';

import './category-add-modal.scss';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAdd,
  faEdit,
  faMinus,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import IconButton from '@mui/material/IconButton';
import { FormControlLabel, FormGroup, Switch, TextField } from '@mui/material';

const editDataDefault = {
  id: null,
  imageName: '',
  cate_thumbnail: '',
  cate_thumbnail_title: '',
  cate_thumbnail_alt: '',
  cate_title: '',
  cate_keyword: '',
  cate_description: '',
  cate_url: '',
  cate_redirect: '',
  cate_position: 1,
  cate_priority: 1,
  old_cate_priority: 1,
  is_menu: false,
  is_bottomside: false,
  is_main_page: false,
  language: '',
  cate_h1: '',
  cate_h2: '',
  meta_title: '',
  meta_description: '',
  meta_keyword: '',
};

const editDataValidDefault = {
  cate_title: false,
  cate_url: false,
};

const ModalEditCategory = (props) => {
  const { isOpen, menuList, categoryData } = props;
  const { t } = useTranslation('category-page');
  const { language, uploadPath } = useSelector((state) => state.app);
  const appEditData = useSelector((state) => state.app.editData);
  const [editData, setEditData] = useState(editDataDefault);
  const [editDataValid, setEditDataValid] = useState(editDataValidDefault);
  const [cateId, setCateId] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [previews, setPreviews] = useState({ src: '', file: null, name: null });
  const webPath = useSelector((state) => state.app.webPath);
  const url = window.location.origin + '/';

  useEffect(() => {
    if (!isOpen) {
      setCateId(0);
      setPreviews({ src: '', file: null, name: null });
      setEditDataValid(editDataValidDefault);
      setEditData(editDataDefault);
    }
  }, [isOpen]);

  useEffect(() => {
    if (appEditData !== null) {
      let newData = {};
      for (let key in appEditData) {
        if (
          key === 'is_main_page' ||
          key === 'is_bottomside' ||
          key === 'is_menu'
        ) {
          newData[`${key}`] = appEditData[key] === 1 ? true : false;
        } else {
          newData[`${key}`] = appEditData[key] !== null ? appEditData[key] : '';
        }
      }

      setCateId(newData.cate_parent_id);
      setEditData({ ...newData, imageName: '' });
      if (newData.cate_thumbnail !== '') {
        setPreviews({ file: null, src: uploadPath + newData.cate_thumbnail });
      }
    }
  }, [appEditData]);

  const setPreviewHandler = (data) => {
    setEditData({ ...editData, imageName: data.file ? data.file.name : '' });
    setPreviews(data);
  };

  const saveModalHandler = () => {
    setEditDataValid({
      ...editDataValid,
      cate_title: editData.cate_title === '',
    });

    if (editData.cate_title === '' || isFetching) {
      return false;
    }

    setIsFetching(true);
    const formData = new FormData();
    const nameImage = editData.cate_thumbnail.split('/');
    const currentImage = nameImage[nameImage.length - 1];
    if (previews.file) {
      formData.append('Image', previews.file);
      formData.append('ImageName', editData.imageName);
    } else {
      formData.append('ImageName', currentImage);
    }

    let c = categoryData.filter((d) => parseInt(d.id) === parseInt(cateId));
    formData.append('id', editData.id);
    formData.append('cate_parent_id', cateId);
    formData.append('cate_level', cateId > 0 ? c[0].cate_level + 1 : 0);
    formData.append(
      'cate_root_id',
      cateId > 0 ? c[0].cate_root_id : editData.id
    );
    formData.append('thumbnail_link', editData.cate_thumbnail);
    formData.append('cate_thumbnail_title', editData.cate_thumbnail_title);
    formData.append('cate_thumbnail_alt', editData.cate_thumbnail_alt);
    formData.append('cate_title', editData.cate_title);
    formData.append('cate_keyword', editData.cate_keyword);
    formData.append('cate_description', editData.cate_description);
    formData.append('cate_url', editData.cate_url);
    formData.append('cate_redirect', editData.cate_redirect);
    // formData.append('cate_position', editData.cate_position);
    formData.append('cate_priority', editData.cate_priority);
    formData.append('old_priority', appEditData.cate_priority);
    formData.append(
      'cate_status_display',
      editData.cate_status_display ? 1 : 0
    );
    formData.append('is_menu', editData.is_menu ? 1 : 0);
    formData.append('is_bottomside', editData.is_bottomside ? 1 : 0);
    formData.append('is_main_page', editData.is_main_page ? 1 : 0);
    formData.append('language', language);
    // formData.append('cate_h1', editData.cate_h1)
    // formData.append('cate_h2', editData.cate_h2)
    // formData.append('meta_title', editData.meta_title)
    // formData.append('meta_description', editData.meta_description)
    // formData.append('meta_keyword', editData.meta_keyword)

    svUpdateCategory(editData.id, formData).then((res) => {
      setIsFetching(false);
      if (res.status) {
        props.setClose(false);
        props.setRefreshData((prev) => prev + 1);
      }
      SwalUI({ status: res.status, description: res.description });
    });
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => props.setClose(false)}
      className={'modal-add-category'}
      aria-labelledby="modal-add-category"
      aria-describedby="modal-add-category"
    >
      <Box className="modal-custom">
        <div className="modal-header">
          <h2>
            <FontAwesomeIcon icon={faEdit} />
            <span>{t('EditCate')}</span>
          </h2>
          <IconButton
            className="param-generator"
            color="error"
            sx={{ p: '10px' }}
            onClick={() => props.setClose(false)}
          >
            <FontAwesomeIcon icon={faXmark} />
          </IconButton>
        </div>
        <div className="modal-body overflow-scroll-custom">
          <fieldset className="modal-fieldset">
            {/* <legend className="modal-legend">{t("ModalEditCategoryTitle")}</legend> */}

            <RadioBoxUI
              className="cate-menu-list"
              t={t}
              disabledId={editData.id}
              data={menuList}
              value={cateId}
              onChange={setCateId}
            />
            <div className="form-details">
              <FieldsetUI className="image-setting" label={t('ModalInfoImage')}>
                <PreviewImageUI
                  className="add-image"
                  previews={previews}
                  setPreviews={setPreviewHandler}
                  setData={setEditData}
                />

                <div className="image-detail">
                  {previews.file && (
                    <TextField
                      onChange={(e) =>
                        setEditData({ ...editData, imageName: e.target.value })
                      }
                      value={editData.imageName}
                      className="text-field-custom"
                      fullWidth={true}
                      error={false}
                      id="image-name"
                      label="Image name"
                      size="small"
                    />
                  )}
                  <TextField
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        cate_thumbnail_title: e.target.value,
                      })
                    }
                    value={editData.cate_thumbnail_title}
                    className="text-field-custom"
                    fullWidth={true}
                    error={false}
                    id="image-title"
                    label="Image title"
                    size="small"
                  />
                  <TextField
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        cate_thumbnail_alt: e.target.value,
                      })
                    }
                    value={editData.cate_thumbnail_alt}
                    className="text-field-custom"
                    fullWidth={true}
                    error={false}
                    id="image-tag"
                    label="Alt description"
                    size="small"
                  />
                </div>
              </FieldsetUI>
              <h3 className="category-detail-title">{t('ModalDetail')}</h3>
              <TextField
                onChange={(e) =>
                  setEditData({ ...editData, cate_title: e.target.value })
                }
                value={editData.cate_title}
                className="text-field-custom"
                fullWidth={true}
                error={editDataValid.cate_title}
                id="cate-title"
                label="Title"
                size="small"
              />
              <TextField
                onChange={(e) =>
                  setEditData({ ...editData, cate_keyword: e.target.value })
                }
                value={editData.cate_keyword}
                className="text-field-custom"
                fullWidth={true}
                error={false}
                id="cate-keyword"
                label="Keyword"
                size="small"
              />
              <TextField
                onChange={(e) =>
                  setEditData({ ...editData, cate_description: e.target.value })
                }
                value={editData.cate_description}
                className="text-field-custom"
                fullWidth={true}
                error={false}
                id="cate-description"
                label="Description"
                size="small"
              />
              <TextField
                onChange={(e) =>
                  setEditData({ ...editData, cate_url: e.target.value })
                }
                placeholder="slug/example"
                value={editData.cate_url}
                className="text-field-custom"
                fullWidth={true}
                error={editDataValid.cate_url}
                id="cate-url"
                label={webPath}
                size="small"
              />
              <TextField
                onChange={(e) =>
                  setEditData({ ...editData, cate_redirect: e.target.value })
                }
                placeholder="Link Url"
                value={editData.cate_redirect}
                className="text-field-custom"
                fullWidth={true}
                error={false}
                id="cate-redirect"
                label="Redirect"
                size="small"
              />
              {/* <h3 className="category-detail-title">{t("Web SEO")}</h3>
              <TextField
                multiline
                onChange={(e) =>
                  setEditData((prevState) => {
                    return { ...prevState, cate_h1: e.target.value }
                  })
                }
                value={editData.cate_h1}
                className="text-field-custom"
                fullWidth={true}
                error={false}
                id="cate-h1"
                label="H1"
                size="small"
              />
              <TextField
                multiline
                onChange={(e) =>
                  setEditData((prevState) => {
                    return { ...prevState, cate_h2: e.target.value }
                  })
                }
                value={editData.cate_h2}
                className="text-field-custom"
                fullWidth={true}
                error={false}
                id="cate-h2"
                label="H2"
                size="small"
              />
              <TextField
                multiline
                onChange={(e) =>
                  setEditData((prevState) => {
                    return { ...prevState, meta_title: e.target.value }
                  })
                }
                value={editData.meta_title}
                className="text-field-custom"
                fullWidth={true}
                error={false}
                id="meta-title"
                label="Meta title"
                size="small"
              />
              <TextField
                multiline
                onChange={(e) =>
                  setEditData((prevState) => {
                    return { ...prevState, meta_description: e.target.value }
                  })
                }
                value={editData.meta_description}
                className="text-field-custom"
                fullWidth={true}
                error={false}
                id="meta-description"
                label="Meta description"
                size="small"
              />
              <TextField
                onChange={(e) =>
                  setEditData((prevState) => {
                    return { ...prevState, meta_keyword: e.target.value }
                  })
                }
                value={editData.meta_keyword}
                className="text-field-custom"
                fullWidth={true}
                error={false}
                id="meta-keyword"
                label="Meta keyword"
                size="small"
              /> */}

              <h3 className="category-detail-title">{t('ModalSetting')}</h3>
              <div className="setting-controls">
                <div className="switch-form">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              cate_status_display: e.target.checked,
                            })
                          }
                          checked={editData.cate_status_display ? true : false}
                        />
                      }
                      label="Display"
                      labelPlacement="start"
                    />
                  </FormGroup>
                </div>
                <div className="switch-form">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              is_menu: e.target.checked,
                            })
                          }
                          checked={editData.is_menu}
                        />
                      }
                      label="Menu"
                      labelPlacement="start"
                    />
                  </FormGroup>
                </div>
                <div className="switch-form">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              is_bottomside: e.target.checked,
                            })
                          }
                          checked={editData.is_bottomside}
                        />
                      }
                      label="Footer Menu"
                      labelPlacement="start"
                    />
                  </FormGroup>
                </div>
                <div className="switch-form">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              is_main_page: e.target.checked,
                            })
                          }
                          checked={editData.is_main_page}
                        />
                      }
                      label="Main Page"
                      labelPlacement="start"
                    />
                  </FormGroup>
                </div>
                {/* {false && (
                  <div className="input-group">
                    <div className="inp">
                      <ButtonUI
                        color="error"
                        onClick={(e) =>
                          editData.cate_position > 1
                            ? setEditData({
                                ...editData,
                                cate_position: editData.cate_position - 1,
                              })
                            : null
                        }
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </ButtonUI>
                      <span className="title">
                        {t('ModalPosition')} {editData.cate_position}
                      </span>
                      <ButtonUI
                        onClick={(e) =>
                          setEditData({
                            ...editData,
                            cate_position: editData.cate_position + 1,
                          })
                        }
                      >
                        <FontAwesomeIcon icon={faAdd} />
                      </ButtonUI>
                    </div>
                  </div>
                )} */}
                <div className="input-group">
                  <div className="inp">
                    <ButtonUI
                      color="error"
                      onClick={(e) =>
                        editData.cate_priority > 1
                          ? setEditData({
                              ...editData,
                              cate_priority: editData.cate_priority - 1,
                            })
                          : null
                      }
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </ButtonUI>
                    <span className="title">
                      {t('ModalPriority')} {editData.cate_priority}
                    </span>
                    <ButtonUI
                      onClick={(e) =>
                        setEditData({
                          ...editData,
                          cate_priority: editData.cate_priority + 1,
                        })
                      }
                    >
                      <FontAwesomeIcon icon={faAdd} />
                    </ButtonUI>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="modal-footer">
          <ButtonUI
            loader={true}
            isLoading={isFetching}
            className="btn-save"
            on="save"
            width="md"
            onClick={saveModalHandler}
          >
            {t('Save')}
          </ButtonUI>
          <ButtonUI
            className="btn-cancel"
            on="cancel"
            width="md"
            onClick={() => props.setClose(false)}
          >
            {t('Cancel')}
          </ButtonUI>
        </div>
      </Box>
    </Modal>
  );
};

export default ModalEditCategory;
